import React, { useState, useEffect } from 'react';

const ScrambleText = ({ originalText }) => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const [scrambledText, setScrambledText] = useState(originalText);
  const [intervalId] = useState(null);

  const startScramble = () => {
    let iteration = 0;

    clearInterval(intervalId);

    const id = setInterval(() => {
      setScrambledText((prevText) =>
        prevText
          .split('')
          .map((letter, index) => {
            if (index < iteration) {
              return originalText[index];
            }

            return letters[Math.floor(Math.random() * 26)];
          })
          .join('')
      );

      if (iteration >= originalText.length) {
        clearInterval(id);
      }

      iteration += 1 / 3;
    }, 30);

  };

  useEffect(() => {
    // Cleanup interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);

  return (
    <h1 style={{cursor:"none"}} onMouseOver={startScramble} onMouseOut={() => clearInterval(intervalId)}>
      {scrambledText}
    </h1>
  );
};

export default ScrambleText;
